import Rules from "@/utils/Rules";
import {showErrorSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper";
import {showDeleteDialogAlert} from "@/utils/DialogAlertHelper";
import SignersService from "@/services/server/SignersService";
import DocumentsService from "@/services/server/DocumentsService";
import cloneDeep from 'lodash/cloneDeep';

const newSigner = () => {
    return {
        name: null,
        email: null,
        phone_number: null,
        birthday: null,
        documentation: null,
        has_documentation: true,
        refusable: false,
        location_required_enabled: false,
        requirements: [],
        communicate_events: {
            signature_request: 'email',
            signature_reminder: 'email',
            document_signed: 'email',
        }
    }
}

export default {
    name: "SignersTab",
    components: {},
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Array,
            default: () => ([])
        },
        idEnvelope: {
            type: String,
            default: null,
        },
        envelopeStatus: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        headers: [
            {text: 'Nome do Signatário', value: 'attributes.name'},
            {text: 'Documentos Associados', value: 'attributes.metadata.docs_assigned'},
            {text: 'Documentos Assinados', value: 'attributes.metadata.docs_signed'},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        documentsSelected: [
            {text: 'Nome do Documento', value: 'document_filename'},
            {text: 'Assinará como', value: 'sign_as'},
            {text: 'Autenticará com', value: 'authenticate_with'},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        documentHeaders: [
            {text: 'Nome do Documento', value: 'attributes.filename'},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        documents: [],
        signerModal: false,
        signer: newSigner(),
        newRoleAndAuth: {
            document_filename: null,
            document_id: null,
            sign_as: null,
            authenticate_with: null,
        },
        signers: [],
        isView: false,
        validFormSigner: true,
        isLoadingSigner: false,
        signerTitleModal: null,
        isLoading: false,
        authenticateWithOptions: [
            {text: 'Email - Token', value: 'email'},
            {text: 'SMS - Token', value: 'sms'},
            {text: 'Whatsapp - Token', value: 'whatsapp'},
            {text: 'Escrita a Mão - Assinatura', value: 'handwritten'},
            {text: 'Prova de Endereço - Imagem', value: 'address_proof'},
            {text: 'Prova de Vida - Imagem', value: 'liveness'},
            {text: 'Foto do Documento - Imagem', value: 'official_document'},
            {text: 'Foto Selfie - Imagem', value: 'selfie'},
            {text: 'Biometria Facial - Imagem', value: 'facial_biometrics'},
            {text: 'Biometria Facial SERPRO - Imagem', value: 'biometric'},
            {text: 'Certificado Digital', value: 'icp_brasil'},
            {text: 'PIX', value: 'pix'},
        ],
        signAsOptions: [{text: 'Correntista', value: 'account_holder'},
            {text: 'Administrador', value: 'administrator'},
            {text: 'Aprovar', value: 'approve'},
            {text: 'Associado(a)', value: 'associate'},
            {text: 'Procurador', value: 'attorney'},
            {text: 'Fiel depositário(a)', value: 'bailee'},
            {text: 'Comodatário', value: 'borrower'},
            {text: 'Corretor(a)', value: 'broker'},
            {text: 'Síndico(a)', value: 'building_manager'},
            {text: 'Parte compradora', value: 'buyer'},
            {text: 'Caucionante', value: 'collateral_provider'},
            {text: 'Comodante', value: 'comforter'},
            {text: 'Anuído', value: 'consented'},
            {text: 'Anuente', value: 'consenting'},
            {text: 'Interveniente Anuente', value: 'consenting_intervenor'},
            {text: 'Consignatário(a)', value: 'consignee'},
            {text: 'Contratada', value: 'contractee'},
            {text: 'Contratante', value: 'contractor'},
            {text: 'Responsável solidário', value: 'co_responsible'},
            {text: 'Credor(a)', value: 'creditor'},
            {text: 'Devedor(es)', value: 'debtor'},
            {text: 'Distratada', value: 'detracted'},
            {text: 'Distratante', value: 'distracting'},
            {text: 'Diretor(a)', value: 'director'},
            {text: 'Empregado(a)', value: 'employee'},
            {text: 'Empregador(a)', value: 'employer'},
            {text: 'Endossatário', value: 'endorsee'},
            {text: 'Endossante', value: 'endorser'},
            {text: 'Franqueado(a)', value: 'franchisee'},
            {text: 'Franqueador(a)', value: 'franchisor'},
            {text: 'Outorgado(a)', value: 'grantee'},
            {text: 'Outorgante', value: 'grantor'},
            {text: 'Avalista', value: 'guarantor'},
            {text: 'Cônjuge do fiador', value: 'guarantor_spouse'},
            {text: 'Corretor de seguros', value: 'insurance_broker'},
            {text: 'Segurado(a)', value: 'insured'},
            {text: 'Intermediário(a)', value: 'intermediary'},
            {text: 'Interveniente', value: 'intervening'},
            {text: 'Interveniente Garantidor', value: 'intervening_guarantor'},
            {text: 'Emitente', value: 'issuer'},
            {text: 'Devedor solidário', value: 'joint_debtor'},
            {text: 'Advogado(a)', value: 'lawyer'},
            {text: 'Responsável legal', value: 'legal_guardian'},
            {text: 'Representante legal', value: 'legal_representative'},
            {text: 'Mutuante', value: 'lender'},
            {text: 'Locatário', value: 'lessee'},
            {text: 'Locador', value: 'lessor'},
            {text: 'Licenciada', value: 'licensed'},
            {text: 'Licenciante', value: 'licensor'},
            {text: 'Gestor', value: 'manager'},
            {text: 'Proprietário(a)', value: 'owner'},
            {text: 'Sócio(a)', value: 'partner'},
            {text: 'Consignado(a)', value: 'pledged'},
            {text: 'Presidente', value: 'president'},
            {text: 'Corretor de imóveis', value: 'real_estate_broker'},
            {text: 'Acusar recebimento', value: 'receipt'},
            {text: 'Morador(a)', value: 'resident'},
            {text: 'Secretário(a)', value: 'secretary'},
            {text: 'Afiançado', value: 'secured'},
            {text: 'Parte vendedora', value: 'seller'},
            {text: 'Prestador(a) de serviços', value: 'service_provider'},
            {text: 'Assinar', value: 'sign'},
            {text: 'Vistoriador', value: 'surveyor'},
            {text: 'Fiador', value: 'surety'},
            {text: 'Cessionário', value: 'transferee'},
            {text: 'Cedente', value: 'transferor'},
            {text: 'Tesoureiro(a)', value: 'treasurer'},
            {text: 'Validador', value: 'validate'},
            {text: 'Testemunha', value: 'witness'}],
        communicateOptions: [
            {
                displayText: 'Solicitação de Assinatura',
                signature_request: [
                    {text: 'Email', value: 'email'},
                    {text: 'Whatsapp', value: 'whatsapp'},
                    {text: 'SMS', value: 'sms'},
                ]
            },
            {
                displayText: 'Lembrete de Assinatura',
                signature_reminder: [
                    {text: 'Sem Notificação', value: 'none'},
                    {text: 'Email', value: 'email'},
                ]
            },
            {
                displayText: 'Conclusão do Envelope',
                document_signed: [
                    {text: 'Email', value: 'email'},
                    {text: 'Whatsapp', value: 'whatsapp'},
                ]
            }
        ],
        expandNotification: false,
        expandDocuments: false,
        expandSelectedDocuments: false,
        selectRoleAndAuthModal: false,
    }),
    computed: {
        ruleRequired() {
            return Rules.required()
        },
        ruleEmail() {
            return Rules.email(false)
        },
        disabledByStatus() {
            return this.envelopeStatus === 'running' || this.envelopeStatus === 'draft'
        }
    },
    methods: {
        async emitSignatureFlowFirebase(newValue) {
            this.$emit('update-firebase-data', newValue);
        },
        wrapFilename(text) {
            if (text && text.length > 50) {
                return text.slice(0, 50) + '...'
            } else return text;
        },
        async viewSigner(item) {
            this.signer = item.attributes;
            this.signer.id = item.id;
            this.isView = true;
            await this.openNewSignerModal()
        },
        async deleteSigner(item) {
            try {
                const result = await SignersService.deleteSigner(this.idEnvelope, item.id);
                this.signers = this.signers.filter(signer => signer.id !== item.id);
                await this.emitSignatureFlowFirebase(result.data.data)
                this.signers = this.signers.filter(signer => signer.id !== item.id);

            } catch (e) {
                console.error(e);
            }
        },
        async confirmDelete(item) {
            showDeleteDialogAlert('Deseja mesmo deletar esse signatário?', (async () => this.deleteSigner(item)));
        },
        deleteSelectedDocument(item) {
            const returnDocument = {
                id: item.document_id,
                attributes: {
                    filename: item.document_filename
                }
            }

            if (item.sign_as_id) {
                this.signer.deletedRequirements = this.signer.deletedRequirements ? this.signer.deletedRequirements : [];

                this.signer.deletedRequirements.push({
                    sign_as_id: item.sign_as_id,
                    authenticate_with_id: item.authenticate_with_id,
                    document_id: item.document_id
                })
            }

            this.documents.push(returnDocument)
            this.signer.requirements = this.signer.requirements.filter(req => req.document_id !== item.document_id)
        },
        saveRoleAndAuth() {
            this.signer.requirements.push(cloneDeep(this.newRoleAndAuth));
            this.documents = this.documents.filter(doc => doc.id !== this.newRoleAndAuth.document_id);
            this.selectRoleAndAuthModal = false;
        },
        openSelectRoleAndAuthModal(item) {
            this.selectRoleAndAuthModal = true;
            this.newRoleAndAuth.document_filename = item.attributes.filename
            this.newRoleAndAuth.document_id = item.id
            this.newRoleAndAuth.sign_as = 'franchisor'
            this.newRoleAndAuth.authenticate_with = 'email'
        },
        async saveSigner() {
            try {
                if (this.signer.id) {
                    this.isLoadingSigner = true;

                    const treatedPayload = {
                        requirementsToAdd: this.signer.requirements.filter((req) => !req.sign_as_id && !req.authenticate_with_id),
                        requirementsToDelete: this.signer.deletedRequirements
                    }

                    const result = await SignersService.updateSignerRequirement(this.idEnvelope, this.signer.id, treatedPayload);

                    this.signers = this.signers.map(signer =>
                        signer.id === this.signer.id
                            ? result.data.data.data
                            : signer
                    );

                    this.signerModal = false;
                    this.isLoadingSigner = false;
                    showSuccessSnackBar("Signatário editado com sucesso!");
                } else {
                    if (!this.signer.name || this.signer.name.trim().split(' ').length < 2) {
                        showErrorSnackBar("O Nome do signatário deve conter Nome e Sobrenome!")
                        return;
                    }

                    if (this.signer.has_documentation) {
                        if (!this.signer.documentation || !this.signer.birthday) {
                            showErrorSnackBar("CPF e Data de Nascimento é obrigatório caso a documentação seja solicitada!")
                            return
                        }
                        this.signer.birthday = this.signer.birthday.split("/").reverse().join('-')
                    }

                    if (this.signer.communicate_events.signature_request && this.signer.communicate_events.signature_request !== 'none') {
                        switch (this.signer.communicate_events.signature_request) {
                            case 'email':
                                if (!this.signer.email) {
                                    showErrorSnackBar("Email é obrigatório quando a notificação de assinatura for Email!")
                                    return
                                }
                                break;

                            case 'sms':
                            case 'whatsapp':
                                if (!this.signer.phone_number) {
                                    showErrorSnackBar("Telefone é obrigatório quando a notificação de assinatura é SMS ou Whatsapp!")
                                    return
                                }
                                break;
                        }
                    }

                    if (!this.signer.requirements.length) {
                        showErrorSnackBar("É obrigatório associar pelo menos 1 documento a esse signatário.")
                        return;
                    }

                    const cleanedObject = {}

                    for (const key in this.signer) {
                        if (this.signer.hasOwnProperty(key) && this.signer[key] !== null) {
                            cleanedObject[key] = this.signer[key];
                        }
                    }
                    this.isLoadingSigner = true;

                    const result = await SignersService.createSigner(this.idEnvelope, cleanedObject);

                    this.signers.push(result.data.data[0].data)

                    this.signerModal = false;
                    this.isLoadingSigner = false;
                    await this.emitSignatureFlowFirebase(result.data.data[1]);
                    showSuccessSnackBar("Signatário adicionado com sucesso!");
                }

            } catch (error) {
                this.signerModal = false;
                this.isLoadingSigner = false;
                console.error("Error: ", error)
            } finally {
                this.isLoadingSigner = false;
            }
        },
        async openNewSignerModal() {
            if (!this.isView) this.signer = newSigner()
            await this.getDocumentsData();
            this.signerTitleModal = this.signer.id ? "Dados do Signatário" : "Cadastrar Novo Signatário"

            this.signerModal = true
        },
        closeSignerModal() {
            this.signerModal = false
            this.isView = false;
        },
        async getDocumentsData() {
            try {
                this.isLoading = true;
                this.documents = []

                const result = await DocumentsService.getAllDocuments(this.idEnvelope);

                for (const doc of result.data.data.data) {
                    this.documents.push(doc)
                }

                this.documents = this.documents.filter(doc => {
                    return !this.signer.requirements.some(req => req.document_id === doc.id);
                });

                this.isLoading = false;
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        },
    },
    watch: {
        'signer.has_documentation': {
            immediate: true,
            handler() {
                this.signer.documentation = null
                this.signer.birthday = null
            }
        },
        param: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.signers = newValue
            }
        },
    },
    async created() {
    },
}